import {PaymentMethod} from "../generated/graphql";

// /////////////////////////////////////////////////////////////////////////////////////////////// //
// ACHTUNG: Dieser Code ist identisch mit dem Code in src/server/lib/getPaymentMethodType.ts       //
// Wir sollten diesen Code in ein gemeinsames Modul auslagern, um die Wartbarkeit zu erhöhen.      //
//                                                                                                 //
// Der Sync wird durch tests/unit/paymentMethod/getPaymentMethodType.sync.test.ts                  //
// automatisch erzwungen — Änderungen müssen in beiden Dateien synchron passieren,                 //
// sonst schlägt der Sync-Test fehl.                                                               //
// /////////////////////////////////////////////////////////////////////////////////////////////// //

export type PaymentMethodType =
    | "cash"
    | "creditCard"
    | "payPal"
    | "sepaDebit"
    | "esr"
    | "bankTransfer"
    | "onlinePayment"
    | "none";

export type PaymentMethodData = Pick<
    PaymentMethod,
    | "cash"
    | "esr"
    | "creditCardAccountholder"
    | "creditcardNumber"
    | "expirationDate"
    | "paypalAccountholder"
    | "email"
    | "iban"
    | "bank"
    | "bic"
    | "sepaAccountholder"
    | "bankTransfer"
    | "onlinePayment"
>;

export const getPaymentMethodType = (
    paymentMethodData?: PaymentMethodData | null,
): PaymentMethodType => {
    // Defensive: Handle undefined/null input
    if (!paymentMethodData) {
        return "none";
    }

    const {
        cash,
        esr,
        creditcardNumber,
        creditCardAccountholder,
        expirationDate,
        sepaAccountholder,
        iban,
        paypalAccountholder,
        email,
        bankTransfer,
        onlinePayment,
    } = paymentMethodData;

    if (onlinePayment === true) {
        return "onlinePayment";
    }

    if (cash === true) {
        return "cash";
    }

    if (bankTransfer === true) {
        return "bankTransfer";
    }

    // Marker vor Feldern: eine ESR-Methode mit IBAN darf nicht auf Lastschrift kippen.
    if (esr === true) {
        return "esr";
    }

    if (
        creditcardNumber !== null &&
        creditcardNumber !== undefined &&
        creditCardAccountholder !== null &&
        creditCardAccountholder !== undefined &&
        expirationDate !== null &&
        expirationDate !== undefined
    ) {
        return "creditCard";
    }

    if (
        sepaAccountholder !== null &&
        sepaAccountholder !== undefined &&
        iban !== null &&
        iban !== undefined
    ) {
        return "sepaDebit";
    }

    if (
        paypalAccountholder !== null &&
        paypalAccountholder !== undefined &&
        email !== null &&
        email !== undefined
    ) {
        return "payPal";
    }

    return "none";
};
